import Patient from './patient';
import Patients from './patients';
import AddPatient from './add-patient';
import Signup from './signup';
import Login from './login';

export {
  Patient,
  Patients,
  AddPatient,
  Signup,
  Login
}



// WEBPACK FOOTER //
// ./src/components/index.js